import { Button, Typography } from '@arco-design/web-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { RootState } from '../../store/store';
import { getButtonColor, getButtonTextColor, getTextColor } from '../../utils/cssVariables';

import '../../components/GuestRoleConversionModal/GuestRoleConversionModal.css';

type GuestRoleChoicePanelProps = {
  id?: string;
  expired?: boolean;
  submitting?: boolean;
  submittingRole?: 'mentor' | 'mentee' | null;
  onSelectRole: (role: 'mentor' | 'mentee') => void;
  align?: 'left' | 'center';
};

export function GuestRoleChoicePanel({
  id,
  expired = false,
  submitting = false,
  submittingRole = null,
  onSelectRole,
  align = 'center',
}: GuestRoleChoicePanelProps) {
  const { t } = useTranslation();
  const brandName = useSelector((state: RootState) => state.config.brandName);
  const displayBrand = brandName.trim() || 'WERULE';
  const textAlign = align === 'left' ? 'left' : 'center';
  const actionsAlignClass =
    align === 'left'
      ? 'guest-role-conversion-modal__actions--align-left'
      : 'guest-role-conversion-modal__actions--align-center';

  const rolePillButtonStyle = {
    color: getButtonTextColor(),
    backgroundColor: getButtonColor(),
    height: 40,
    borderRadius: 20,
  };

  return (
    <div id={id} className="guest-role-conversion-modal" style={{ marginTop: 8 }}>
      <Typography.Title
        heading={4}
        className="alice-regular guest-role-conversion-modal__title"
        style={{ textAlign }}
      >
        {expired
          ? t('guest_conversion.title_expired', { brandName: displayBrand })
          : t('guest_conversion.title')}
      </Typography.Title>
      <Typography.Text
        className="guest-role-conversion-modal__body"
        style={{ color: getTextColor(), textAlign }}
      >
        {expired ? t('guest_conversion.body_expired') : t('guest_conversion.body')}
      </Typography.Text>
      <div className={`guest-role-conversion-modal__actions ${actionsAlignClass}`}>
        <Button
          className="guest-role-conversion-modal__action-btn"
          htmlType="button"
          shape="round"
          size="large"
          loading={submitting && submittingRole === 'mentor'}
          disabled={submitting}
          onClick={() => onSelectRole('mentor')}
          style={rolePillButtonStyle}
        >
          {t('guest_conversion.mentor_button')}
        </Button>
        <Button
          className="guest-role-conversion-modal__action-btn"
          htmlType="button"
          shape="round"
          size="large"
          loading={submitting && submittingRole === 'mentee'}
          disabled={submitting}
          onClick={() => onSelectRole('mentee')}
          style={rolePillButtonStyle}
        >
          {t('guest_conversion.mentee_button')}
        </Button>
      </div>
      <Typography.Text
        className="guest-role-conversion-modal__body"
        style={{ color: getTextColor(), fontSize: 13, textAlign }}
      >
        {t('guest_conversion.profile_next_note')}
      </Typography.Text>
    </div>
  );
}
